import script from "./dashboard-list.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard-list.vue?vue&type=script&setup=true&lang=js"

import "./dashboard-list.vue?vue&type=style&index=0&id=59fd24a5&lang=less&scoped=true"

import exportComponent from "/builds/ChinaApplicationPool/dia/smart-search/mobile-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fd24a5"]])

export default __exports__